export default __webpack_public_path__ + "static/media/FoodAndBeverageBackground375x250.fc72512d.png";